<template lang="html">
  <canvas class="signal-gauge"></canvas>
</template>

<script>
export default {
  name: 'signal-gauge',
  props: {
    level: Number
  },
  data: function () {
    return {
      signalLevels: 5,
      width: 200,
      height: 150,
      radius: 10,
      x: 0,
      y: 0
    }
  },
  watch: {
    level: function (signalStrenght) {
      const canvas = this.$el
      const ctx = canvas.getContext('2d')
      const level = this.level
      ctx.clearRect(0, 0, canvas.width, canvas.height)
      this.drawBase(ctx, level)
      this.drawSignalStrength(ctx, level)
      this.drawEmptySignalLevels(ctx, this.signalLevels, level)
    }
  },
  mounted: function () {
    const canvas = this.$el
    const canvasWidth = this.width
    const canvasHeight = this.height
    canvas.width = canvasWidth
    canvas.height = canvasHeight
    this.x = canvasWidth / 2
    this.y = canvasHeight - this.radius
    const ctx = canvas.getContext('2d')
    const level = this.level
    this.drawBase(ctx, level)
    this.drawSignalStrength(ctx, level)
    this.drawEmptySignalLevels(ctx, this.signalLevels, level)
  },
  methods: {
    drawBase: function (ctx, signalStrenght) {
      ctx.beginPath()
      ctx.arc(this.x, this.y, this.radius, 0, 2 * Math.PI)
      if (signalStrenght > 0) {
        ctx.fillStyle = '#00ccff'
      } else {
        ctx.fillStyle = '#808080'
      }
      ctx.fill()
    },
    drawSignalStrength: function (ctx, signalStrenght) {
      for (let i = 0; i < signalStrenght; i++) {
        ctx.beginPath()
        ctx.arc(this.x, this.y, 30 * i, this.degreesToRadians(225), this.degreesToRadians(315))
        ctx.lineWidth = 2 * this.radius
        ctx.strokeStyle = '#00ccff'
        ctx.stroke()
      }
    },
    drawEmptySignalLevels: function (ctx, signalLevels, signalStrenght) {
      for (let i = signalStrenght; i < signalLevels; i++) {
        ctx.beginPath()
        ctx.arc(this.x, this.y, 30 * i, this.degreesToRadians(225), this.degreesToRadians(315))
        ctx.lineWidth = 2 * this.radius
        ctx.strokeStyle = '#808080'
        ctx.stroke()
      }
    },
    degreesToRadians: function (degrees) {
      return degrees * Math.PI / 180
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Gauges/Signal.vue